var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMachine = function SvgMachine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M3.667 13.333h1.666m6-7.333h.007M5.333 4H3.467c-.747 0-1.12 0-1.406.145-.25.128-.454.332-.582.583-.146.285-.146.659-.146 1.405v2.4c0 .747 0 1.12.146 1.406.127.25.331.455.582.582.286.146.659.146 1.406.146h1.866m4.8 2.666h2.4c.747 0 1.12 0 1.406-.145.25-.128.454-.332.582-.583.146-.285.146-.658.146-1.405V4.8c0-.747 0-1.12-.146-1.405a1.33 1.33 0 0 0-.582-.583c-.286-.145-.659-.145-1.406-.145h-2.4c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C8 3.68 8 4.053 8 4.8v6.4c0 .747 0 1.12.145 1.405.128.251.332.455.583.583.285.145.659.145 1.405.145M12 10a.667.667 0 1 1-1.333 0A.667.667 0 0 1 12 10"
  })));
};
export default SvgMachine;